import React from "react";
import {
    Box,
    Container,
    Tab,
    Tabs,
    AppBar,
    Card,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import Page from '../../components/Page';
import FleetMap from './ServiceMap/index';
import ServiceFaultStatus from './ServiceStatus/index';
import ServiceInfo from './ServiceInfo/index';
import { connect, useSelector } from 'react-redux';
import theme from "../../theme";
import Toolbar from './ServiceToolbar';
import { maxHeight } from "@mui/system";
import { styled } from '@mui/system';

const MyPage = styled(Page)({
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
})

const ServiceView = (props) => {
    const [data, setData] = React.useState([]);

    return (
        <MyPage title="Service Management" >
            <Container maxWidth={false}>
                <Toolbar data={data} setData={setData} hideLimit={false} />
                <Box mt={3}>
                    <Box sx={{ height: 800}} >
                        <Box height={'50%'} width={'100%'} sx={{ border: '1px solid',display: 'flex',flexDirection: 'row' }}>
                            <ServiceInfo />
                            <FleetMap title="I'm the map." />
                        </Box>                        
                        <Box height={'50%'} width={'100%'} >
                            <ServiceFaultStatus />
                        </Box>
                    </Box>
                </Box>
            </Container>
        </MyPage>
    );
}
export default ServiceView;
